import { render, staticRenderFns } from "./SponsorList-newDesign.vue?vue&type=template&id=cbf3a9fc"
import script from "./SponsorList-newDesign.vue?vue&type=script&lang=js"
export * from "./SponsorList-newDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports